<!--
 * @Description: 融资事件详情页
 * @Author: ll
 * @Date: 2021-07-20 13:42:25
 * @LastEditTime: 2021-07-20 13:43:57
 * @LastEditors: ll
-->
<template>
  <div class="detail">
    <a-tabs v-model="activeName">
      <a-tab-pane tab="融资事件" key="detail" />
    </a-tabs>
    <div class="investName">
      <img src="@/assets/images/companyImage.jpg" alt="" />
      <span>{{ orgName }}</span>
    </div>
    <div class="table">
      <div class="title">
        <span class="desc1"></span>
        <span class="desc2">公开投资事件</span>
      </div>
      <a-table
        :row-key="(record) => record.index"
        :loading="loading"
        :columns="columns"
        :data-source="tableData"
        :pagination="{
          pageSize: pageSize,
          current: pageNum,
          total: total,
          showQuickJumper: true, //显示跳转页数
          showSizeChanger: true, // 显示可改变每页数量
          pageSizeOptions: ['20'], // 每页数量选项
          showTotal: (total) => `共 ${total} 条`, //显示总数
        }"
        @change="onChange"
      >
        <template slot="num" slot-scope="text, action, index">
          {{ index + 1 }}
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { listInvestorFinancing } from '../../api/financingEventDetail';
const columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'num' },
  },
  {
    title: '公司名称',
    dataIndex: 'company',
    key: 'company',
  },
  {
    title: '所属行业',
    dataIndex: 'hangye1',
    key: 'hangye1',
  },
  {
    title: '地区',
    key: 'location',
    dataIndex: 'location',
  },
  {
    title: '投资日期',
    key: 'investTime',
    dataIndex: 'investTime',
  },
  {
    title: '投资金额',
    key: 'money',
    dataIndex: 'money',
  },
  {
    title: '获资信息',
    key: 'lunci',
    dataIndex: 'lunci',
  },
];

export default {
  data: () => ({
    activeName: 'detail',
    tableData: [],
    columns,
    total: 0,
    pageNum: 1,
    pageSize: 20,
    loading: false,
    orgName: '',
  }),
  mounted() {
    this.getList();
  },
  methods: {
    onChange({ current, pageSize }) {
      this.pageNum = current;
      this.pageSize = pageSize;
      this.getList();
    },
    async getList() {
      this.orgName = this.$route.query.orgName || '用友网络科技股份有限公司';
      let data = {
        beginTime: '',
        endTime: '',
        orgName: this.orgName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      const res = await listInvestorFinancing(data);
      this.loading = false;
      this.tableData = res.data.list;
      this.tableData.map((item, index) => {
        item.index = index++;
      });
      this.total = res.data.total;
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  padding: 0 20px 20px;
  // font-family: PingFangSC-Regular, PingFang SC !important;
}
::v-deep .ant-tabs-tab-active {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFang SC;
  padding: 12px 0;
  &:hover {
    color: #333;
  }
}
::v-deep .ant-tabs-ink-bar {
  background: #0072f7;
  width: 64px !important;
}
.investName {
  padding: 4px 0 20px;
  border-bottom: 1px solid #f0f0f0;
  img {
    height: 70px;
    width: 70px;
    margin-right: 16px;
    border: 1px solid #f0f0f0;
  }
  span {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
  }
}
.table {
  margin: 35px 0 16px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .desc1 {
      display: inline-block;
      width: 2px;
      height: 16px;
      background: #0072f7;
    }
    .desc2 {
      margin-left: 7px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }
  }
}

::v-deep .ant-table-thead > tr > th,
::v-deep .ant-table-fixed .ant-table-thead > tr > th {
  padding: 0 16px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
}
::v-deep .ant-table-tbody > tr > td,
::v-deep .ant-table-fixed .ant-table-tbody > tr > td {
  padding: 0 16px;
  font-size: 14px;
  // font-weight: 400;
  // color: #333333;
  height: 40px;
  font-family: PingFangSC-Regular, PingFang SC !important;
}
</style>
